import { ErrorHandling } from "@serenity-is/corelib";

window.onerror = ErrorHandling.runtimeErrorHandler;
